import React from 'react';
import PropTypes from 'prop-types';
import { categoryIdOf } from '../../../flow/blocks/booking/CategoryChips';

/**
 * The modal's native <select>, optionally grouped under category headings
 * (Appointment Journey → "Enable Category"): one <optgroup> per category
 * that has items, in the location's category order, then "Other" for
 * uncategorised ones.
 */
const GroupedSelect = ({
  name,
  value,
  onChange,
  disabled,
  placeholder,
  items,
  renderLabel,
  categories,
  categoryType,
  groupByCategory
}) => {
  const option = (item) => (
    <option key={item.id} value={item.id}>
      {renderLabel(item)}
    </option>
  );

  let body = items.map(option);
  if (groupByCategory) {
    const groups = (categories || [])
      .filter((c) => !c.type || c.type === categoryType)
      .map((category) => ({
        category,
        items: items.filter((item) => String(categoryIdOf(item)) === String(category.id))
      }))
      .filter((group) => group.items.length);
    const grouped = new Set(groups.flatMap((g) => g.items.map((item) => item.id)));
    const other = items.filter((item) => !grouped.has(item.id));
    if (groups.length) {
      body = [
        ...groups.map(({ category, items: groupItems }) => (
          <optgroup key={category.id} label={category.name}>
            {groupItems.map(option)}
          </optgroup>
        )),
        ...(other.length
          ? [
              <optgroup key="other" label="Other">
                {other.map(option)}
              </optgroup>
            ]
          : [])
      ];
    }
  }

  return (
    <select
      className="form-control"
      name={name}
      value={value || ''}
      disabled={disabled}
      onChange={onChange}>
      <option value="" disabled>
        {placeholder}
      </option>
      {body}
    </select>
  );
};

GroupedSelect.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  items: PropTypes.array,
  renderLabel: PropTypes.func,
  categories: PropTypes.array,
  categoryType: PropTypes.string,
  groupByCategory: PropTypes.bool
};

export default GroupedSelect;
